// extracted by mini-css-extract-plugin
export default {"button":"panel-header_button__v3N-+","placeHolderShimmer":"panel-header_placeHolderShimmer__kV-R9"};